import React, { useEffect, useState } from "react";
import {MenuItem,Select,Typography,Box,SelectChangeEvent,TextField,IconButton,InputAdornment,} from "@mui/material";
import BoxLayoutContent from "@/shared/components/layout/boxLauotContent";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import CardBoxLayout from "../../layout/cardBoxLayout";
import BoxKit from "@/shared/components/kit/box";
import SendIcon from "@mui/icons-material/Send";
import CustomButton from "@/shared/components/kit/button";
import { useMutation, useQuery } from "@tanstack/react-query";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { fetchListTicketUser,postRequestSendTicketUser,} from "@/api/user/home";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { ListTicketUserData } from "@/types/api/user/home.type.data";
import { AvatarImg } from "@/shared/components/common/icons";
import { useMediaQuery } from "react-responsive";
/**
 * SelectWithButtons
 *
 * کامپوننت پشتیبانی با انتخاب موضوع درخواست و ارسال پیام.
 *
 * ویژگی‌ها:
 * - نمایش Select برای انتخاب نوع درخواست (امور مالی، فنی، مشتریان و …)
 * - نمایش دکمه‌ها برای انتخاب سریع موضوع
 * - لیست پیام‌های کاربر بر اساس نوع انتخابی
 * - TextField برای نوشتن پیام جدید
 * - امکان پیوست تصویر به پیام و پیش‌نمایش آن
 * - ارسال پیام با استفاده از mutation و بروزرسانی لیست پیام‌ها
 * - ریسپانسیو با استفاده از react-responsive برای موبایل
 *
 * @returns JSX.Element
 */

export default function SelectWithButtons() {
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [currentValue, setCurrentValue] = useState<string>("");
  const [activeValue, setActiveValue] = useState<string | null>(null);
  const [textFieldValue, setTextFieldValue] = useState("");
  const [secondTabEnabled, setSecondTabEnabled] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const isMobile = useMediaQuery({ maxWidth: 900 });

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedImage(file);
      const imageUrl = URL.createObjectURL(file);
      setImagePreview(imageUrl);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
    const fileInput = document.getElementById("image-upload") as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }
  };
  const {data: dataTicketUser,isLoading: isloadingTicketUser,isSuccess,refetch,} = useQuery<ListTicketUserData>({
    queryKey: ["ticketUser-list-dataPayment"],
    queryFn: fetchListTicketUser,
  });

  useEffect(() => {
    if (isSuccess) {
      setSecondTabEnabled(false);
    }
  }, [isSuccess]);

  const [typeRequest, setTypeRequest] = useState("");
  const [valueOption, setStateValueOption] = useState([
    {
      id: 1,
      type: "finance",
      value: "امور مالی",
    },
    {
      id: 2,
      type: "technical",
      value: "امور فنی",
    },
    {
      id: 3,
      type: "customer",
      value: "امور مشتریان",
    },
    {
      id: 4,
      type: "commerce",
      value: "امور بازرگانی",
    },
    {
      id: 5,
      type: "etc",
      value: "امور درخواست پذیرندگی",
    },
    {
      id: 6,
      type: "etc",
      value: "موارد دیگر",
    },
  ]);

  const { mutate: fetchRequestSendTicketUser } = useMutation({
    mutationFn: postRequestSendTicketUser,
    onSuccess: (data: any) => {
      refetch();
      setTextFieldValue("");
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message);
    },
  });

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTextFieldValue(e.target.value);
  };
  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    const selectedItem = valueOption.find((item) => item.value === value);
    if (selectedItem && !selectedValues.includes(value)) {
      setSelectedValues((prev) => [...prev, value]);
      setCurrentValue(value);
      setTypeRequest(selectedItem.type);
      refetch();
    }
    setCurrentValue(value);
  };

  const handleSendMessage = () => {
    const requestBody = {
      image: selectedImage,
      message: textFieldValue,
      type: typeRequest,
    };
    fetchRequestSendTicketUser(requestBody);
  };

  useEffect(() => {
    if (valueOption.length > 0) {
      const defaultItem = valueOption[0];
      setCurrentValue(defaultItem.value);
      setSelectedValues([defaultItem.value]);
      setActiveValue(defaultItem.value);
      setTypeRequest(defaultItem.type);
      setSecondTabEnabled(true);
      refetch();
    }
  }, [valueOption]);

  return (
    <BoxLayoutContent
      titleElement={
        <StackKit direction={"row"} flexWrap="wrap" alignItems="center" gap={1}>
          <TypoGraphyKit variant="h6">
            <MessageOutlinedIcon />
          </TypoGraphyKit>
          <TypoGraphyKit variant="h6">پشتیبانی</TypoGraphyKit>
        </StackKit>
      }
    >
      <StackKit sx={{ width: "100%" }} alignItems={"end"} gap={1}>
        <Select
          value={currentValue}
          onChange={handleChange}
          displayEmpty
          sx={{ minWidth: isMobile ? "100%" : 200, maxWidth: 220 }}
        >
          <MenuItem value="" disabled>
            انتخاب کنید
          </MenuItem>
          {valueOption.map((item) => (
            <MenuItem key={item.id} value={item.value}>
              {item.value}
            </MenuItem>
          ))}
        </Select>

        <BoxKit
          mt={2}
          sx={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            justifyContent: isMobile ? "center" : "flex-start",
          }}
        >
          {selectedValues.map((value) => {
            const correspondingItem = valueOption.find((item) => item.value === value);
            return (
              <CustomButton
                sx={{
                  background:
                    "linear-gradient(135.42deg, rgba(55, 55, 55, 0.78) -13.12%, #0C0C0C 121.4%)",
                  minWidth: isMobile ? "100%" : "auto",
                  flex: isMobile ? 1 : "unset",
                }}
                key={value}
                onClick={() => {
                  setActiveValue(value);
                  if (correspondingItem) setTypeRequest(correspondingItem.type);
                  setSecondTabEnabled(true);
                }}
              >
                <TypoGraphyKit
                  variant="body1"
                  sx={{ color: activeValue === value ? "#fff" : "gray" }}
                >
                  {value}
                </TypoGraphyKit>
              </CustomButton>
            );
          })}
        </BoxKit>

        {activeValue && (
          <CardBoxLayout sx={{display:'flex',flexDirection:'column',gap:2}}>
            <StackKit sx={{ width: "100%",padding:1 }}>
              {dataTicketUser?.[typeRequest as keyof ListTicketUserData]?.map((item) => (
                <StackKit
                  key={item.id}
                  direction={isMobile ? "column" : "row"}
                  alignItems={"start"}
                  justifyContent={"start"}
                  gap={2}
                  sx={{ mb: 2 }}
                >
                  <StackKit className="overflow-hidden bg-[#2C2B3F] rounded-full p-2">
                    <AvatarImg width={"50"} height={"50"} />
                  </StackKit>
                  <StackKit sx={{ width: "100%" }}>
                    <Box
                      sx={{
                        p: 1,
                        borderRadius: "8px",
                        background:
                          "linear-gradient(97.77deg, rgba(0, 0, 0, 0.4) -9.73%, rgba(23, 23, 23, 0.281106) 16.04%, rgba(115, 103, 240, 0.25) 50.23%, rgba(65, 65, 65, 0.231942) 87.66%, rgba(0, 0, 0, 0.16) 109.42%)",
                        maxWidth: isMobile ? "100%" : "540px",
                        textAlign: "right",
                      }}
                    >
                      <Typography variant="body1">کاربر:</Typography>
                      <Typography variant="body1">{item.message}</Typography>
                    </Box>
                  </StackKit>
                </StackKit>
              ))}
            </StackKit>

            <StackKit
              direction={isMobile ? "column" : "row"}
              sx={{ width: "100%" }}
              gap={1}
              alignItems={isMobile ? "stretch" : "center"}
              justifyContent={"space-between"}
            >
              <TextField
                placeholder="پیام خود را بنویسید..."
                onChange={handleChangeInput}
                multiline
                minRows={imagePreview ? 3 : 1}
                sx={{
                  width: isMobile ? "100%" : "90%",
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "#323232",
                    borderRadius: "10px",
                    alignItems: "flex-start",
                  },
                  "& .MuiOutlinedInput-input": {
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    paddingTop: imagePreview ? "80px" : "8px",
                  },
                }}
                InputProps={{
                  startAdornment: imagePreview && (
                    <Box sx={{ position: "absolute", top: 8, right: 8 }}>
                      <Box sx={{ position: "relative" }}>
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{
                            width: 60,
                            height: 60,
                            borderRadius: 6,
                            objectFit: "cover",
                            border: "1px solid #555",
                          }}
                        />
                        <IconButton
                          onClick={handleRemoveImage}
                          sx={{
                            position: "absolute",
                            top: -8,
                            right: -8,
                            bgcolor: "error.main",
                            color: "white",
                            width: 20,
                            height: 20,
                          }}
                        >
                          <HighlightOffIcon sx={{ fontSize: 14 }} />
                        </IconButton>
                      </Box>
                    </Box>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <input
                        id="image-upload"
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                      />
                      <IconButton component="label" htmlFor="image-upload" sx={{ color: "#7367f0" }}>
                        <CloudUploadIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <CustomButton
                disabled={textFieldValue === ""}
                onClick={handleSendMessage}
                sx={{ width: isMobile ? "100%" : "auto" }}
              >
                <SendIcon style={{ transform: "rotate(-130deg)", color: "#fff" }} />
              </CustomButton>
            </StackKit>
          </CardBoxLayout>
        )}
      </StackKit>
    </BoxLayoutContent>
  );
}